export default __webpack_public_path__ + "static/media/(18).a2364e23.jpg";